import { Component, OnInit, Input, ViewChild, Inject, OnChanges } from '@angular/core';
import { trigger, transition, state, animate, style, AnimationEvent } from '@angular/animations';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  animations: [
    trigger('openDropdown', [
      // ...
      state('open', style({
        height: '*',
        opacity: 1,
      })),
      state('closed', style({
        height: 'initial',
        opacity: 1,
      })),
      transition('* => *', [
        animate('0.3s')
      ]),
    ])],
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  public currentYear: number = new Date().getFullYear();

  constructor() { }

  ngOnInit() {
  }

}
